import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../shared/Button";
import Input from "../shared/Input";
import Card from "../shared/Card";
import { requestPasswordReset } from "../../api/auth";
import Swal from "sweetalert2";
import logo from "../../assets/chatea.png";

const RecoverPassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email) {
      newErrors.email = "El correo electrónico es requerido";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Correo electrónico inválido";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      const data = await requestPasswordReset(formData);
      Swal.fire({
        icon: "success",
        title: "Solicitud enviada",
        text: data,
      });

      navigate("/login");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Error al enviar la solicitud de recuperación",
      });
    } finally {
      setLoading(false);
    }
  };

  const navigateToLogin = () => {
    navigate("/login");
  };

  const navigateToRegister = () => {
    navigate("/register");
  };

  return (
    <Card logo={logo} title="Recuperar contraseña" className="login-form">
      <form onSubmit={handleSubmit} className="login-form__form">
        <p className="recovery-form__instructions">
          Ingresa tu correo electrónico y te enviaremos un enlace para
          restablecer tu contraseña.
        </p>
        <Input
          type="email"
          label="Correo Electrónico"
          name="email"
          value={formData.email}
          onChange={handleChange}
          error={errors.email}
        />
        <Button type="submit" variant="primary" disabled={loading} fullWidth>
          {loading ? "Enviando..." : "Enviar enlace de recuperación"}
        </Button>
        <p className="login-form__register" onClick={navigateToLogin}>
          Iniciar sesión
        </p>
        <p className="login-form__register" onClick={navigateToRegister}>
          ¿No tienes una cuenta? Registrarse
        </p>
      </form>
    </Card>
  );
};

export default RecoverPassword;
